import React from 'react';
import { reminderHelpers } from './reminder-helpers';
import { Form } from "react-bootstrap";
import PropTypes from 'prop-types';

const SelectReminderType = ({ taskReminder, setTaskReminder }) => {

    return (
        <div className="elements-container">
            <div className="reminder-options-container">
                <Form.Check
                    type="checkbox"
                    name="reminders"
                    checked={taskReminder.reminder.id == 0}
                    label="On Due Date"
                    disabled={!taskReminder.exist}
                    onClick={() => {
                        if (taskReminder.exist)
                            reminderHelpers.setOnDueDate(setTaskReminder);
                    }}
                />
                <Form.Check
                    type="checkbox"
                    name="reminders"
                    checked={
                        taskReminder.reminder.id == 2 ||
                        taskReminder.reminder.id == 3
                    }
                    label="One-Time"
                    disabled={!taskReminder.exist}
                    onClick={() => {
                        if (taskReminder.exist)
                            reminderHelpers.setOneTime(setTaskReminder);
                    }}
                />
                <Form.Check
                    type="checkbox"
                    name="reminders"
                    checked={taskReminder.reminder.id == 1}
                    label="Recurring"
                    disabled={!taskReminder.exist}
                    onClick={() => {
                        if (taskReminder.exist)
                            reminderHelpers.setRecurring(setTaskReminder);
                    }}
                />
                <Form.Check
                    type="checkbox"
                    name="reminders"
                    checked={taskReminder.reminder.id == 4}
                    label="Custom"
                    disabled={!taskReminder.exist}
                    onClick={() => {
                        if (taskReminder.exist)
                            reminderHelpers.setCustom(setTaskReminder);
                    }}
                />
            </div>
        </div>
    );
};

SelectReminderType.propTypes = {
    taskReminder: PropTypes.shape({
        exist: PropTypes.bool,
        reminder: PropTypes.shape({
            id: PropTypes.number,
        }),
    }),
    setTaskReminder: PropTypes.func.isRequired,
};

export default SelectReminderType;